var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('transition',{attrs:{"name":"fade"}},[_c('g',[(_vm.all_done)?_c('g',[_c('text',{staticClass:"txt",attrs:{"x":"0","y":"-10","text-anchor":"middle","dominant-baseline":"middle","font-family":"sans-serif","font-size":"50","fill":"#000000"}},[_vm._v(_vm._s(_vm.text.allDone))])]):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }